import { NgClass } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslatePipe } from '@ngx-translate/core';
import { ServiceTranslated } from 'src/app/models/serviceTranslated';

@Component({
  selector: 'app-services-mini',
  imports: [
    MatIconModule,
    NgClass,
    MatTooltipModule,
    MatButtonModule,
    FlexLayoutModule,
    TranslatePipe,
  ],
  templateUrl: './services-mini.component.html',
  styleUrl: './services-mini.component.scss',
})
export class ServicesMiniComponent {
  readonly services = input.required<ServiceTranslated[]>();
  readonly accessButtonClick = output<{
    url: string;
    title: string;
  }>();
  readonly helpButtonClick = output<string>();

  openService(service: ServiceTranslated): void {
    this.accessButtonClick.emit({
      url: service.accessurl,
      title: service.title,
    });
  }

  openDocumentation(helpUrl: string): void {
    this.helpButtonClick.emit(helpUrl);
  }
}
